import { useSelector } from "react-redux";

import { useOfferGroupsActions } from "store/OfferGroupsSlice";

const useOfferGroups = () => {
  const { loadOfferGroups, switchCurrentOffer, clearCurrentOffer, setCurrentOffer } = useOfferGroupsActions();

  const { currentOffer, offerGroups, allOffers } = useSelector((state) => state.OfferGroupsSlice);

  return {
    currentOffer,
    offerGroups,
    offers: offerGroups?.offers || [],
    allOffers,
    loadOfferGroups,
    switchCurrentOffer,
    setCurrentOffer,
    clearCurrentOffer,
  };
};

export default useOfferGroups;
